// extracted by mini-css-extract-plugin
export var accordion = "_e2-0";
export var chevron = "_e2-3";
export var closed = "_e2-2";
export var content = "_e2-4";
export var open = "_e2-1";
export var rotate = "_e2-5";